"use strict";

var _App;
import '@autoguru/overdrive/dist/styles/global/reset.css';
import '@autoguru/overdrive/dist/styles/global/fonts.css';
import { LoggingAgentProvider } from '@autoguru/logs';
import { AsyncBoundary } from '@autoguru/suspense';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { getMfeMountPoint } from 'gdu/dist/lib/mfe';
import { App } from './App';
import { routeMap } from '~/src/pages/routeMap';
import * as guruConfigs from '../guru.config';
import { jsx as _jsx } from "react/jsx-runtime";
const root = getMfeMountPoint({
  mountDOMId: guruConfigs.mountDOMId,
  projectName: __GDU_APP_NAME__
});
const MFE = () => {
  createRoot(root).render(/*#__PURE__*/_jsx(StrictMode, {
    children: /*#__PURE__*/_jsx(LoggingAgentProvider, {
      children: /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: null,
        children: /*#__PURE__*/_jsx(Router, {
          future: {
            v7_startTransition: true
          },
          children: /*#__PURE__*/_jsx(Routes, {
            children: /*#__PURE__*/_jsx(Route, {
              path: `${routeMap.slug}`,
              element: _App || (_App = /*#__PURE__*/_jsx(App, {}))
            })
          })
        })
      })
    })
  }));
};
export default MFE;